import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, LegalSection } from "./LegalLayout";

export const AGB = () => (
  <LegalLayout
    eyebrow="Rechtliches"
    title="Allgemeine Geschäftsbedingungen"
    testId="agb-page"
  >
    <LegalSection title="1. Geltungsbereich">
      <p>
        Diese Allgemeinen Geschäftsbedingungen gelten für alle Bestellungen
        über den Online-Shop der
      </p>
      <p>
        Pflegeheld Handels GmbH
        <br />
        Bahnhofstraße 71
        <br />
        31515 Wunstorf
        <br />
        Deutschland
      </p>
      <p>vertreten durch den Geschäftsführer Jan Brinkmann.</p>
      <p>
        Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei
        denn, ihrer Geltung wird ausdrücklich schriftlich zugestimmt.
      </p>
    </LegalSection>

    <LegalSection title="2. Vertragsgegenstand">
      <p>
        Die Pflegeheld Handels GmbH vertreibt Pflegehilfsmittel,
        Hygieneartikel sowie Pflegeboxen für Privatkunden und pflegebedürftige
        Personen.
      </p>
      <p>
        Sofern angeboten, können Pflegeboxen im Rahmen des gesetzlichen
        Anspruchs auf Pflegehilfsmittel gemäß § 40 SGB XI direkt mit der
        jeweiligen Pflegekasse abgerechnet werden.
      </p>
    </LegalSection>

    <LegalSection title="3. Vertragsschluss">
      <p>
        Die Darstellung der Produkte im Online-Shop stellt kein rechtlich
        bindendes Angebot dar, sondern eine unverbindliche
        Produktpräsentation.
      </p>
      <p>
        Mit Absenden der Bestellung gibt der Kunde ein verbindliches Angebot
        zum Abschluss eines Kaufvertrages ab.
      </p>
      <p>
        Der Vertrag kommt erst durch ausdrückliche Auftragsbestätigung oder
        durch Versand der Ware zustande.
      </p>
    </LegalSection>

    <LegalSection title="4. Preise und Versandkosten">
      <p>
        Alle angegebenen Preise verstehen sich inklusive der gesetzlichen
        Mehrwertsteuer.
      </p>
      <p>
        Sofern Versandkosten anfallen, werden diese im Bestellprozess
        gesondert ausgewiesen.
      </p>
    </LegalSection>

    <LegalSection title="5. Zahlungsbedingungen / Abrechnung mit der Pflegekasse">
      <p>
        Bei Pflegeboxen und Pflegehilfsmitteln gemäß § 40 SGB XI erfolgt die
        Abrechnung grundsätzlich direkt mit der jeweiligen Pflegekasse des
        Kunden.
      </p>
      <p>
        Voraussetzung hierfür ist das Vorliegen eines gültigen Anspruchs auf
        Pflegehilfsmittel sowie die Unterzeichnung einer entsprechenden
        Abtretungs- bzw. Kostenübernahmeerklärung durch den Kunden bzw. die
        pflegebedürftige Person.
      </p>
      <p>
        Der Kunde leistet in diesem Fall keine eigene Zahlung, soweit die
        Kosten vollständig durch die Pflegekasse übernommen werden.
      </p>
      <p>
        Sollte eine Kostenübernahme durch die Pflegekasse ganz oder teilweise
        abgelehnt werden und die Ware bereits geliefert worden sein, behält
        sich die Pflegeheld Handels GmbH vor, die entstandenen Kosten dem
        Kunden entsprechend in Rechnung zu stellen.
      </p>
      <p>
        Der Kunde verpflichtet sich, alle für die Abrechnung erforderlichen
        Angaben vollständig und wahrheitsgemäß bereitzustellen.
      </p>
    </LegalSection>

    <LegalSection title="6. Lieferung und Versand">
      <p>Die Lieferung erfolgt an die vom Kunden angegebene Lieferadresse.</p>
      <p>
        Lieferzeiten sind unverbindlich, sofern nicht ausdrücklich etwas
        anderes vereinbart wurde.
      </p>
      <p>
        Teillieferungen sind zulässig, soweit dies für den Kunden zumutbar
        ist.
      </p>
    </LegalSection>

    <LegalSection title="7. Pflegebox-Abonnement">
      <p>
        Sofern ein regelmäßiges Pflegebox-Modell angeboten wird, erfolgt die
        Lieferung monatlich oder im vereinbarten Lieferintervall.
      </p>
      <p>
        Das Vertragsverhältnis kann vom Kunden jederzeit ohne Angabe von
        Gründen in Textform (z. B. per E-Mail) gekündigt werden.
      </p>
      <p>
        Die Kündigung wird zum Ende des laufenden Monats wirksam, sofern sie
        vor dem letzten Werktag des jeweiligen Monats eingeht.
      </p>
      <p>
        Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt
        unberührt.
      </p>
      <p>
        Mit Beendigung des Anspruchs auf Pflegehilfsmittel gegenüber der
        Pflegekasse endet das Vertragsverhältnis automatisch zum
        entsprechenden Zeitpunkt.
      </p>
    </LegalSection>

    <LegalSection title="8. Mitwirkungspflichten des Kunden">
      <p>
        Der Kunde verpflichtet sich, sämtliche für die Beantragung und
        Abrechnung mit der Pflegekasse erforderlichen Unterlagen und
        Informationen vollständig und wahrheitsgemäß bereitzustellen.
      </p>
      <p>
        Änderungen der Pflegekasse, des Pflegegrades, der Anschrift oder
        anderer relevanter Daten sind unverzüglich mitzuteilen.
      </p>
    </LegalSection>

    <LegalSection title="9. Eigentumsvorbehalt">
      <p>
        Bis zur vollständigen Bezahlung bleibt die Ware Eigentum der
        Pflegeheld Handels GmbH.
      </p>
    </LegalSection>

    <LegalSection title="10. Widerrufsrecht">
      <p>
        Verbrauchern steht ein gesetzliches Widerrufsrecht zu. Einzelheiten
        ergeben sich aus der gesonderten{" "}
        <Link to="/widerruf" className="text-[#3FA66D] hover:underline">
          Widerrufsbelehrung
        </Link>
        .
      </p>
    </LegalSection>

    <LegalSection title="11. Ausschluss des Widerrufsrechts">
      <p>
        Das Widerrufsrecht kann bei versiegelten Hygiene- und Pflegeartikeln
        erlöschen, wenn deren Versiegelung nach der Lieferung entfernt wurde.
      </p>
    </LegalSection>

    <LegalSection title="12. Gewährleistung">
      <p>Es gelten die gesetzlichen Gewährleistungsrechte.</p>
    </LegalSection>

    <LegalSection title="13. Haftung">
      <p>
        Die Pflegeheld Handels GmbH haftet unbeschränkt bei Vorsatz und grober
        Fahrlässigkeit.
      </p>
      <p>
        Bei einfacher Fahrlässigkeit haftet die Pflegeheld Handels GmbH nur
        bei Verletzung wesentlicher Vertragspflichten und begrenzt auf den
        vorhersehbaren Schaden.
      </p>
      <p>Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.</p>
    </LegalSection>

    <LegalSection title="14. Datenschutz">
      <p>
        Informationen zur Verarbeitung personenbezogener Daten befinden sich
        in der{" "}
        <Link to="/datenschutz" className="text-[#3FA66D] hover:underline">
          Datenschutzerklärung
        </Link>{" "}
        auf der Website.
      </p>
    </LegalSection>

    <LegalSection title="15. Streitbeilegung">
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#3FA66D] hover:underline"
        >
          Online-Streitbeilegungsplattform der EU
        </a>
        .
      </p>
      <p>
        Die Pflegeheld Handels GmbH ist nicht verpflichtet und nicht bereit,
        an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
      </p>
    </LegalSection>

    <LegalSection title="16. Schlussbestimmungen">
      <p>
        Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des
        UN-Kaufrechts.
      </p>
      <p>
        Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden,
        bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
      </p>
    </LegalSection>
  </LegalLayout>
);

export default AGB;
